// src/components/ui/Button.jsx
import clsx from "clsx";

export default function Button({
  children,
  variant = "primary", // primary | secondary | danger | warning | success
  size = "md", // sm | md | lg
  smSize = "md",
  mdSize = "md",
  lgSize = "lg",
  onClick,
  type = "button",
  className = "",
  disabled = false,
}) {
  const baseClasses =
    "inline-flex items-center justify-center rounded-lg font-medium shadow-sm transition focus:outline-none focus:ring-2 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed";

  const sizeMap = {
    sm: "px-2 py-1 text-[11px]",
    md: "px-3 py-1.5 text-sm",
    lg: "px-4 py-2 text-base",
  };

  const responsiveSizes = clsx(
    sizeMap[size] || sizeMap.md,
    `sm:${sizeMap[smSize] || sizeMap.md}`,
    `md:${sizeMap[mdSize] || sizeMap.md}`,
    `lg:${sizeMap[lgSize] || sizeMap.lg}`
  );

  const variants = {
    primary: "bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500",
    secondary: "bg-gray-200 text-gray-900 hover:bg-gray-300 focus:ring-gray-400",
    danger: "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500",
    warning: "bg-yellow-500 text-white hover:bg-yellow-600 focus:ring-yellow-400",
    success: "bg-green-600 text-white hover:bg-green-700 focus:ring-green-500",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        baseClasses,
        responsiveSizes,
        variants[variant],
        className
      )}
    >
      {children}
    </button>
  );
}
